'use strict';

angular.module('amexReconciliationApp')
  .component('transactionReviewIcon', {
    templateUrl: 'scripts/views/components/transaction-review-icon.html',
    bindings: { transaction: '<' },
    controller: function () {

      var self = this;
      
      self.displayReviewIcon = function () {
        return self.transaction.mutableTransactionProperties.transactionStatus !== 'NOT_REVIEWED';
      };

      self.getTransactionReviewToolTip = function() {
        var transactionStatus = self.transaction.mutableTransactionProperties.transactionStatus;

        switch(transactionStatus) {
          case 'REVIEWED':
            return 'transactions.titles.ReviewedHoverOverText';
          case 'REALLOCATED':
            return 'transactions.titles.ReallocatedHoverOverText';
          default:
            return '';
        }
      };

      self.getIcon = function () {
        var transactionStatus = self.transaction.mutableTransactionProperties.transactionStatus;
        var transactionAllocationsSize = self.transaction.allocationsSize;
        switch(transactionStatus) {
          case 'REVIEWED':
            return 'success-font fa-eye';
          case 'REALLOCATED':
            if(transactionAllocationsSize > 1)
              return 'type-amex-blue fa-calculator';
            else
              return 'success-font fa-calculator';
          default:
            return '';
        }
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionReviewIcon.js
// module id = 498
// module chunks = 0